const React = require('react');

class SmallLogo extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 239.39 404.71" className={this.props.className}>
                <g id="Layer_2" data-name="Layer 2">
                    <g id="Logo">
                        <path className="cls-1" fill="#5c1500" d="M45.33,72.47l23.58,43.64-4.43,2.39L45.62,83.59l-1.28,38.63-2.18,1.18L9.24,103.48,28,138.21l-4.43,2.39L0,97,3.8,94.9,40.24,117l1.28-42.5Z"/>
                        <path className="cls-1" fill="#5c1500" d="M111.93,77.8,87.62,90.94l1.06,14.49L83.88,108,80.25,53.6l4.55-2.46L128.33,84l-4.86,2.62ZM108.23,75,85.09,57.19l2.19,29.1Z"/>
                        <path className="cls-1" fill="#5c1500" d="M147.56,54.13l8.15,15.08-4.55,2.46L143,56.58,110.12,37.46,115,34.8l28.21,16.42L145,18.63l4.61-2.49Z"/>
                        <path className="cls-1" fill="#5c1500" d="M206.59,26.66,182.27,39.8l1.06,14.49-4.8,2.59L174.9,2.46,179.45,0,223,32.86l-4.87,2.63Zm-3.71-2.83L179.74,6.05l2.19,29.1Z"/>
                        <path className="cls-1" fill="#5c1500" d="M230.21,57.4l-104,55.89,91.09,29.26c-2.33,7.89-39.24,132.67-41.61,140.7L62.82,250.52C65.11,242.65,92.28,148.84,94.56,141l83.62,24.09c-2.26,7.62-21.73,73.44-23.92,80.87l-53.93-14.71c2.12-7.15,13.56-45.82,15.63-52.83l26.28,7.77c-2.17,6.91-10.25,32.52-10.25,32.52l8.78,2.77L153.84,180l-44.1-13-20.9,70.67,71.69,19.56,29.11-98.4L88.28,129.58s-.43,1.46-.8,2.76L34.79,166.17s24.65,55.18,25.94,58.08c-.82,2.88-8,28.12-8,28.14s-1.28,4.41-1.28,4.41l4.4,1.28,23.38,7,62.94,139.67,36-111.19,3.85,1.12,46.76-158.1-4.26-1.37-5.31-1.77,20.25-80.93-9.18,4.93m-4.81,13-15.06,60.2-60.67-19.49L225.4,70.44M83.58,145.78,64.77,210.72,46.43,169.64l37.15-23.86m7.14,122.41L169.25,291c-2.33,7.22-23,71-28.52,88.2-7.64-16.94-43.69-96.94-50-111"/>
                    </g>
                </g>
            </svg>
        )
    }
}

module.exports = SmallLogo;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/SmallLogo/index.jsx